import { render, staticRenderFns } from "./CustomerCalls.vue?vue&type=template&id=6d5fb8e9&"
import script from "./CustomerCalls.vue?vue&type=script&lang=js&"
export * from "./CustomerCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports